import { Pipe, PipeTransform } from '@angular/core';
import { ICompanyNameAndOffice } from '../../models/dashboard.model';

@Pipe({
    standalone: false,
    name: 'transformOfficeId'
})
export class OfficeIdTransform implements PipeTransform {
    transform(value: ICompanyNameAndOffice): string {
        if (!value) {
            return ''
        };
        return `${value.companyName} (${value.officeId})`
    }
}